import { Injectable } from '@angular/core';
import { CanActivate, CanLoad, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { JwtTokenService } from '../services/jwtToken.service';

@Injectable({
  providedIn: 'root'
})
export class UserGuard implements CanActivate, CanLoad {
  constructor(private router: Router, private jwtTokenService: JwtTokenService) {}

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUser();
  }

  canLoad(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.checkUser();
  }

  private checkUser() {
    if (this.jwtTokenService.jwtToken && !this.jwtTokenService.isTokenExpired()) {
      return true;
    }    

    const redirectLoginAd = window.location.hash.includes('page/admin');
    if(redirectLoginAd) {
      this.router.navigate(['/login-ad']);    
    } else {
      this.router.navigate(['/login']);    
    }
    return false;
  }
}
